<template>
    <div class="d-flex align-center">
        <span class="caption grey--text mr-2" v-if="error">
            <v-icon small color="error">sync_problem</v-icon> Falha ao atualizar
        </span>
        <span class="caption grey--text mr-2" v-else-if="lastUpdate">Atualizado às {{ lastUpdate }}</span>
        <v-progress-circular :value="progress" :indeterminate="loading" :color="error ? 'error' : 'primary'" size="34" width="4" rotate="-90" class="refresh-timer">
            <span class="caption font-weight-bold">{{ loading ? "" : seconds }}</span>
        </v-progress-circular>
    </div>
</template>

<script>
export default {
    name: "RefreshTimer",

    props: {
        remaining: { type: Number, required: true },
        interval: { type: Number, required: true },
        loading: { type: Boolean, default: false },
        error: { type: Boolean, default: false },
        lastUpdate: { type: String, default: null },
    },

    computed: {
        progress() {
            return Math.max(0, Math.min(100, (this.remaining / this.interval) * 100));
        },
        seconds() {
            return Math.max(0, Math.ceil(this.remaining / 1000));
        },
    },
};
</script>

<style scoped>
.refresh-timer >>> .v-progress-circular__overlay {
    transition: stroke-dashoffset 0.25s linear;
}
</style>
